$.fn.previousStep = function() {
    let $stepActive = $(this).find('.step--active'),
        $stepPrevious = $stepActive.prev('.step');

    if ($stepPrevious.length > 0) {
        $stepActive.removeClass('step--active');
        $stepPrevious.addClass('step--active');

        $(this).moveTrackToIndex($stepPrevious.index());
        $(this).checkControls();
        $(this).setProgressBar();
    }
}

$.fn.nextStep = function() {
    let $stepActive = $(this).find('.step--active'),
        $stepNext = $stepActive.next('.step');

    if ($stepNext.length > 0) {
        $stepActive.removeClass('step--active');
        $stepNext.addClass('step--active');

        $(this).moveTrackToIndex($stepNext.index());
        $(this).checkControls();
        $(this).setProgressBar();
    }
}

$.fn.checkControls = function() {
    let $stepActive = $(this).find('.step--active'),
        $controlPrevious = $(this).find('.wizard__btn--previous'),
        $controlPreviousLabel = $controlPrevious.find('.btn__label'),
        $controlNext = $(this).find('.wizard__btn--next'),
        $controlNextLabel = $controlNext.find('.btn__label'),
        $controlFinish = $(this).find('.wizard__btn--finish'),
        controlPreviousLabelOverwrite = $stepActive.data('control-previous-label'),
        controlNextLabelOverwrite = $stepActive.data('control-next-label');

    if ($stepActive.length > 0) {
        if ($stepActive.prev('.step').length < 1) {
            $controlPrevious.prop('disabled', true);
        } else {
            $controlPrevious.prop('disabled', false);
        }

        if ($stepActive.next('.step').length < 1) {
            $controlNext.prop('disabled', true);
        } else {
            $controlNext.prop('disabled', false);
        }

        if (typeof controlPreviousLabelOverwrite !== 'undefined') {
            $controlPrevious.data('original-label', $controlPreviousLabel.text());
            $controlPreviousLabel.text(controlPreviousLabelOverwrite);
        } else {
            let originalLabel = $controlPrevious.data('original-label');

            if (originalLabel !== 'undefined') {
                $controlPreviousLabel.text(originalLabel);
            }
        }

        if (typeof controlNextLabelOverwrite !== 'undefined') {
            $controlNext.data('original-label', $controlNextLabel.text());
            $controlNextLabel.text(controlNextLabelOverwrite);
        } else {
            let originalLabel = $controlNext.data('original-label');

            if (originalLabel !== 'undefined') {
                $controlNextLabel.text(originalLabel);
            }
        }

        // check if last slide, show finish btn if it exists
        if ($stepActive.next('.step').length < 1 && $controlFinish.length > 0) {
            $controlNext.hide();
            $controlFinish.show();
        } else {
            $controlNext.show();
            $controlFinish.hide();
        }
    }
}

$.fn.moveTrackToIndex = function(index) {
    let $wizard = $(this),
        $track = $wizard.find('.wizard__track'),
        $steps = $wizard.find('.wizard__steps');

    if (typeof index !== 'undefined') {
        let $stepActive = $wizard.find('.step').eq(index),
            topOffset = 0;

        // add height of all previous questions to offset
        $stepActive.prevAll('.step').each(function () {
            topOffset = topOffset + $(this).outerHeight();
        });

        // move steps vertically
        $steps.css({'transform' : 'translate3d(0, -'+ topOffset +'px, 0)'});

        // set track height to match height of new active step
        $track.css('maxHeight', $stepActive.outerHeight());
    }
}

$.fn.setProgressBar = function(index) {
    let $progressBar = $(this).find('.wizard__progress-fill'),
        activeIndex = $(this).find('.step--active').index() + 1,
        totalSteps = $(this).find('.step').length;

    $progressBar.css('width', (activeIndex / totalSteps * 100)+'%');
}

$('.wizard').each(function() {
    let $wizard = $(this),
        $track = $wizard.find('.wizard__track'),
        $stepActive = $wizard.find('.step--active'),
        $controlPrevious = $wizard.find('.wizard__btn--previous'),
        $controlNext = $wizard.find('.wizard__btn--next');

    // check if active step exists, else set first step as active
    if (!$stepActive.length > 0) {
        $stepActive = $wizard.find('.step').first().addClass('step--active');
    }

    // set track height to match height of first step
    $track.css('maxHeight', $stepActive.outerHeight());

    $controlPrevious.on('click', function() {
        $wizard.previousStep();
    });

    $controlNext.on('click', function() {
        $wizard.nextStep();
    });

    $wizard.checkControls();
    $wizard.setProgressBar();
});